import axios, { AxiosRequestConfig } from 'axios';
import { TOKEN_KEY } from 'configs';
import { getFromLocal, removeFromLocal } from './cache';
import { LOGIN } from 'configs/routeNames';

type ApiRequestConfig = AxiosRequestConfig & Partial<{ includeAuth: boolean; autoContentType?: boolean }>;

/**
 * Every /api/** call needs `Authorization: Bearer <token>` - the backend is an
 * OAuth2 resource server validating Microsoft Entra ID JWTs (see the UAM CMS
 * Backend Postman collection).
 */
const request = async (
  url: string,
  { includeAuth = false, headers = {}, autoContentType = false, ...axiosRequestConfig }: ApiRequestConfig,
) => {
  if (includeAuth) {
    const token = getFromLocal(TOKEN_KEY, false) as string | null;
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (!autoContentType) {
    headers['Content-Type'] = 'application/json';
  }

  const result = await axios(url, {
    headers,
    ...axiosRequestConfig,
  });
  return result.data;
};

export const errorInterceptor = (error: any) => {
  if (error.response) {
    const { status } = error.response;
    if (status === 401 || status === 403) {
      removeFromLocal(TOKEN_KEY);
      if (globalThis.location.pathname !== `/${LOGIN}`) {
        globalThis.location.href = `/${LOGIN}`;
      }
    }
  }
  return Promise.reject(error);
};

export const successInterceptor = (response: any) => response;

export const setupApiInterceptors = () => {
  axios.interceptors.response.use(successInterceptor, errorInterceptor);
};

export default request;
